import React from 'react';

type IconProps = {
    className?: string;
};

export function TikTokIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1-2.59-2.59 2.59 2.59 0 0 1 2.59-2.59c.27 0 .53.04.78.1v-3.16a5.78 5.78 0 0 0-.78-.05 5.84 5.84 0 0 0-5.84 5.84 5.84 5.84 0 0 0 5.84 5.84 5.84 5.84 0 0 0 5.84-5.84V8.89a7.27 7.27 0 0 0 4.77 1.75v-3.09a4.28 4.28 0 0 1-1.09-.73z"
            />
        </svg>
    );
}

export function YouTubeIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M10 15.5v-7l6 3.5-6 3.5zm11.5-8.2c-.2-1-1-1.7-2-1.9C17.6 5 12 5 12 5s-5.6 0-7.5.4c-1 .2-1.8 1-2 1.9C2 9.3 2 12 2 12s0 2.7.5 4.7c.2 1 1 1.7 2 1.9 1.9.4 7.5.4 7.5.4s5.6 0 7.5-.4c1-.2 1.8-1 2-1.9.5-2 .5-4.7.5-4.7s0-2.7-.5-4.7z"
            />
        </svg>
    );
}

export function InstagramIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 1 1 17.25 6 1.25 1.25 0 0 1 18.5 4.5M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
            />
        </svg>
    );
}

export function XIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            />
        </svg>
    );
}

export function FacebookIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2.3V12h2.3V9.8c0-2.3 1.3-3.5 3.4-3.5 1 0 2 .2 2 .2v2.2h-1.1c-1.1 0-1.4.7-1.4 1.4V12h2.4l-.4 2.9h-2v7A10 10 0 0 0 22 12z"
            />
        </svg>
    );
}

export function LinkedInIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 1 1 8.3 6.5a1.75 1.75 0 0 1-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0 0 13 14.19a.66.66 0 0 0 0 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 0 1 2.7-1.4c1.55 0 3.36.86 3.36 3.66z"
            />
        </svg>
    );
}

export function HudlIcon({ className }: IconProps) {
    return (
        <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M4 4h16v16H4V4zm3.5 3.5v9h2.3V12h1.4l2.1 4.5h2.6l-2.3-4.8c1.2-.4 2-1.5 2-3 0-1.9-1.5-3.2-3.8-3.2H7.5zm2.3 2h1.2c.8 0 1.3.4 1.3 1.1s-.5 1.1-1.3 1.1H9.8V9.5z"
            />
        </svg>
    );
}
